import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation, useParams } from "react-router-dom";

import MountedWrapper from "../../component/mountedWrapper/MountedWrapper";
import AdFitAd from "../../component/ad/AdFitAd";
import { getProductDetailAdId } from "../../util/url";

/**
 * 상품 상세 광고 배너
 */
export default function ProductDetailAdBanner({ hostname }) {
  const { pathname } = useLocation();
  const { productId: encodedProductId } = useParams();
  const productId = parseInt(encodedProductId, 36);

  const [adKey, setAdKey] = useState(0);

  useEffect(() => {
    setAdKey((k) => k + 1);
  }, [pathname, productId]);

  return (
    <MountedWrapper>
      <div className="Product-details-ad mt-5">
        <AdFitAd
          key={adKey}
          width={320}
          height={50}
          unit={getProductDetailAdId(hostname)}
          style={{ width: 350, height: 50 }}
        />
      </div>
    </MountedWrapper>
  );
}

ProductDetailAdBanner.propTypes = {
  hostname: PropTypes.string.isRequired,
};
